import { render, staticRenderFns } from "./BookReviews.vue?vue&type=template&id=057de46a&"
import script from "./BookReviews.vue?vue&type=script&lang=js&"
export * from "./BookReviews.vue?vue&type=script&lang=js&"
import style0 from "./BookReviews.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports